<template>
  <div class="property-tab">
    <PrioritiesTable :items="regions" label="Region"></PrioritiesTable>
    <DocumentationEditor :model="model"></DocumentationEditor>
  </div>
</template>

<script setup lang="ts">
import { Statechart } from "../mvc/statechart";
import { Region } from "../mvc/region";
import { onMounted, computed, onBeforeUnmount } from "vue";
import PrioritiesTable from "./PrioritiesTable.vue";
import DocumentationEditor from "../StatechartDefinitionsView/DocumentationEditor.vue";

const compProps = defineProps<{ model: Statechart }>();
const emit = defineEmits(["notifyChange"]);

const changeNotifier = (model) => {
  emit("notifyChange", model);
};

onMounted(() => {
  compProps.model.on("change", changeNotifier, compProps.model);
  regions.value.forEach((r) => {
    r.on("change", changeNotifier, r);
  });
});

onBeforeUnmount(() => {
  compProps.model.off("change", changeNotifier);
  regions.value.forEach((r) => {
    r.off("change", changeNotifier);
  });
});

const regions = computed((): Array<Region> => {
  return compProps.model.getTopLevelRegions();
});
</script>
